import * as React from 'react';
import { Loader } from '../Loader';
import { DateFilter } from '../DateFilter';
import { injectIntl } from 'react-intl';
import { TranslateText } from '../TranslateText';

// PropType definition
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
;

// Header component with props and its types
const _DualListWidget = props => {
  const {
    loader,
    width,
    title,
    disabled,
    dateFilterTitle,
    dateFilter,
    dateFilterOptions,
    dateFilterValue,
    onTriggerDateFilterChange,
    dateFilterDateFormat,
    column1Value,
    column2Value
  } = props;
  return /*#__PURE__*/_jsx(React.Fragment, {
    children: /*#__PURE__*/_jsx("div", {
      className: `kc-ui-colm kc-ui-dual-list ${disabled && "kc-ui-disabled "}  ${loader && "kc-ui-loader-overlay"}`,
      style: {
        width: `${width}`
      },
      children: /*#__PURE__*/_jsxs("div", {
        className: "kc-ui-colm-div",
        children: [title ? /*#__PURE__*/_jsx("h4", {
          children: /*#__PURE__*/_jsx(TranslateText, {
            id: title
          })
        }) : null, /*#__PURE__*/_jsx("div", {
          className: "kc-ui-datefilter-div",
          children: dateFilter && /*#__PURE__*/_jsx(DateFilter, {
            title: dateFilterTitle,
            options: dateFilterOptions,
            value: dateFilterValue,
            onTriggerChange: onTriggerDateFilterChange,
            dateFormat: dateFilterDateFormat
          })
        }), loader ? /*#__PURE__*/_jsx(Loader, {
          loader: loader
        }) : /*#__PURE__*/_jsx(React.Fragment, {
          children: /*#__PURE__*/_jsxs("div", {
            className: "kc-ui-dual-list-div",
            children: [column1Value ? /*#__PURE__*/_jsx("div", {
              className: "kc-ui-dual-list-key",
              children: /*#__PURE__*/_jsx("ul", {
                className: "kc-ui-nobullet",
                children: /*#__PURE__*/_jsx("li", {
                  children: column1Value?.map((column, index) => {
                    return /*#__PURE__*/_jsx("p", {
                      children: /*#__PURE__*/_jsx(TranslateText, {
                        id: column.label
                      })
                    }, index);
                  })
                })
              })
            }) : null, column2Value ? /*#__PURE__*/_jsx("div", {
              className: "kc-ui-dual-list-value",
              children: /*#__PURE__*/_jsx("ul", {
                className: "kc-ui-nobullet",
                children: /*#__PURE__*/_jsx("li", {
                  children: column2Value?.map((column, index) => {
                    return /*#__PURE__*/_jsx("p", {
                      children: /*#__PURE__*/_jsx(TranslateText, {
                        id: column.label
                      })
                    }, index);
                  })
                })
              })
            }) : null]
          })
        })]
      })
    })
  });
};

// Prop type definition for compile time

// Default props
_DualListWidget.defaultProps = {
  loader: false,
  width: "100%",
  title: "",
  disabled: false,
  dateFilterTitle: '',
  dateFilter: false,
  dateFilterOptions: [],
  onTriggerDateFilterChange: () => {},
  dateFilterValue: {},
  dateFilterDateFormat: "MM/dd/yyyy",
  column1Value: [],
  column2Value: []
};
export const DualListWidget = injectIntl( /*#__PURE__*/React.memo(_DualListWidget));